let FilterLineups = {
    FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER: 'FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER',
    FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO: 'FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO',
    FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO:
        'FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO',
    FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO:
        'FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO',
};

export default FilterLineups;
